import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit, faTrash, faPlus, faCheckCircle, faTimesCircle } from "@fortawesome/free-solid-svg-icons";
import { useNotification } from "../../context/NotificationContext";
import { loadSmsTriggerEvent } from "../../api/adminApi";

const SmsEventSettings = () => {
  const [eventList, setEventList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const { notifyError } = useNotification();
  const navigate = useNavigate();

  useEffect(() => {
    loadSmsTriggerEvent()
      .then((response) => {
        setEventList(response.data);
        setLoading(false);
      })
      .catch((err) => {
        console.error("Error loading SMS event settings:", err);
        setError("Failed to load SMS event settings");
        notifyError("Failed to load SMS event settings");
        setLoading(false);
      });
  }, []);

  const handleEdit = (item) => {
    navigate(`/admin/add-sms-event/${item.id}`);
  };

  const handleDelete = (item) => {
    console.log("Delete", item);
  };

  return (
    <div className="p-6">
      <div className="flex items-center justify-between mb-6">
        <h2 className="text-2xl font-bold text-gray-800">SMS Event Settings</h2>
        <button
          className="bg-orange-500 hover:bg-orange-600 text-white px-4 py-2 rounded-xl shadow-md transition"
          onClick={() => navigate("/admin/add-sms-event")}
        >
          <FontAwesomeIcon icon={faPlus} className="mr-2" />
          Add Event
        </button>
      </div>

      {loading && <div className="text-gray-600">Loading...</div>}
      {error && <div className="text-red-500">{error}</div>}

      {!loading && !error && (
        <div className="overflow-x-auto shadow border rounded-xl">
          <table className="min-w-full text-sm text-gray-800">
            <thead className="bg-gray-100 text-xs uppercase font-semibold text-gray-600">
              <tr>
                <th className="px-6 py-3 text-left">Trigger Event</th>
                <th className="px-6 py-3 text-left">Priority</th>
                <th className="px-6 py-3 text-left">Progress Status</th>
                <th className="px-6 py-3 text-left">Status</th>
                <th className="px-6 py-3 text-left">Updated By</th>
                <th className="px-6 py-3 text-left">Updated At</th>
                <th className="px-6 py-3 text-center">Action</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200">
              {eventList.length === 0 ? (
                <tr>
                  <td colSpan="7" className="text-center py-6 text-gray-500">
                    No event settings found.
                  </td>
                </tr>
              ) : (
                eventList.map((event, index) => (
                  <tr key={index} className="hover:bg-gray-50 transition">
                    <td className="px-6 py-4">{event.smsTriggerEvent}</td>
                    <td className="px-6 py-4">{event.priority}</td>
                    <td className="px-6 py-4">{event.progressStatus}</td>
                    <td className="px-4 py-3">
                      <span className={`inline-flex items-center gap-1 px-3 py-1 rounded-full text-xs font-semibold border ${event.status === "Active"
                        ? "bg-green-50 text-green-700 border-green-300"
                        : "bg-red-50 text-red-700 border-red-300"
                        }`}>
                        <FontAwesomeIcon
                          icon={event.status === "Active" ? faCheckCircle : faTimesCircle}
                          className="text-sm"
                        />
                        {event.status}
                      </span>
                    </td>
                    <td className="px-6 py-4">{event.createdBy}</td>
                    <td className="px-6 py-4">{event.updatedAt}</td>
                    <td className="px-6 py-4 text-center space-x-2">
                      <button
                        onClick={() => handleEdit(event)}
                        title="Edit"
                        className="inline-flex items-center justify-center w-8 h-8 border border-blue-500 text-blue-600 rounded hover:bg-blue-50 transition"
                      >
                        <FontAwesomeIcon icon={faEdit} />
                      </button>
                      <button
                        onClick={() => handleDelete(event)}
                        title="Delete"
                        className="inline-flex items-center justify-center w-8 h-8 border border-red-500 text-red-600 rounded hover:bg-red-50 transition"
                      >
                        <FontAwesomeIcon icon={faTrash} />
                      </button>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default SmsEventSettings;
